import { __assign, __read, __values } from "tslib";
import { useCapabilities } from '@office-start/capabilities-service';
import { useAppBarUserData } from '@office-start/data-resolver-app-pinning';
import * as React from 'react';
import { NovaDataContext } from './NovaDataContext';
import { useCurrentInUseTileID } from './useCurrentInUseTileID';
import { useEnterpriseAppBarTileData } from './useEnterpriseAppBarTileData';
export var NovaEnterpriseDataProvider = function (_a) {
    var children = _a.children;
    var appBarTileData = useEnterpriseAppBarTileData();
    var inUseTileID = useCurrentInUseTileID();
    var _b = __read(useAppBarUserData(), 2), userData = _b[0], setUserData = _b[1];
    var capabilities = useCapabilities().data;
    var tileData = React.useMemo(function () {
        var e_1, _a;
        var _b;
        // create copy of original edge data
        var appEdges = appBarTileData.m365Apps.edges.slice();
        appEdges.forEach(function (edge) {
            edge.node.isInUse = edge.node.id === inUseTileID;
        });
        if ((userData === null || userData === void 0 ? void 0 : userData.pinnedApps) && appEdges) {
            var _loop_1 = function (edge) {
                var pinnedIndex = (_b = userData.pinnedApps.find(function (state) { return state.id === edge.node.id; })) === null || _b === void 0 ? void 0 : _b.pinnedIndex;
                edge.node.pinnedIndex = pinnedIndex;
            };
            try {
                for (var appEdges_1 = __values(appEdges), appEdges_1_1 = appEdges_1.next(); !appEdges_1_1.done; appEdges_1_1 = appEdges_1.next()) {
                    var edge = appEdges_1_1.value;
                    _loop_1(edge);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (appEdges_1_1 && !appEdges_1_1.done && (_a = appEdges_1.return)) _a.call(appEdges_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        if (capabilities === null || capabilities === void 0 ? void 0 : capabilities.appBarOverflowOnlyEnabled) {
            appEdges = appEdges.filter(function (item) {
                return (item.node.lockedIndex !== undefined ||
                    item.node.pinnedIndex !== undefined ||
                    item.node.isInUse);
            });
        }
        return {
            m365Apps: __assign(__assign({}, appBarTileData.m365Apps), { edges: appEdges }),
        };
    }, [
        appBarTileData,
        capabilities === null || capabilities === void 0 ? void 0 : capabilities.appBarOverflowOnlyEnabled,
        inUseTileID,
        userData === null || userData === void 0 ? void 0 : userData.pinnedApps,
    ]);
    return (React.createElement(NovaDataContext.Provider, { value: { tileData: tileData, userData: userData, setUserData: setUserData } }, children));
};
export default NovaEnterpriseDataProvider;
//# sourceMappingURL=NovaEnterpriseDataProvider.js.map